import { render, staticRenderFns } from "./SaitenBoxScoreStamp.vue?vue&type=template&id=0a8dee3a&scoped=true&"
import script from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
export * from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenBoxScoreStamp.vue?vue&type=style&index=0&id=0a8dee3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dee3a",
  null
  
)

export default component.exports